// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
export const uploadTokenId = (z.number());
export const uploadToken = z.object({
    id: uploadTokenId,
    token: z.string(),
    target_type: z.string(),
    target_id: z.number(),
    expires_at: z.date(),
    created_at: z.date(),
});
export const uploadTokenInitializer = z.object({
    id: uploadTokenId.optional(),
    token: z.string(),
    target_type: z.string().optional(),
    target_id: z.number().optional(),
    expires_at: z.date(),
    created_at: z.date().optional(),
});
export const uploadTokenMutator = z.object({
    id: uploadTokenId.optional(),
    token: z.string().optional(),
    target_type: z.string().optional(),
    target_id: z.number().optional(),
    expires_at: z.date().optional(),
    created_at: z.date().optional(),
});
//# sourceMappingURL=UploadToken.js.map